import { render, staticRenderFns } from "./Bargainshare.vue?vue&type=template&id=2705ffb0&scoped=true"
import script from "./Bargainshare.vue?vue&type=script&lang=js"
export * from "./Bargainshare.vue?vue&type=script&lang=js"
import style0 from "./Bargainshare.vue?vue&type=style&index=0&id=2705ffb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705ffb0",
  null
  
)

export default component.exports